import {
  EOB_LOADING,
  EOB_SUCCESS,
  EOB_FAILED
} from '../actions/eobActions'

const EOBFile = (state = { error: null }, action) => {
  switch (action.type) {
    case EOB_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        eobFile: null,
        error: null
      })
    case EOB_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        eobFile: action.response.resourceFilesField,
        error: null
      })
    case EOB_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        eobFile: null,
        error: action.error
      })
    default:
      return state
  }
}
export default EOBFile



// WEBPACK FOOTER //
// ./src/redux/reducers/eobReducer.js